import { Link } from "react-router-dom";
import { Lightbulb, ArrowRight } from "lucide-react";

export const AcaPromiseBanner = ({ className = "" }) => (
  <div
    data-testid="aca-promise-banner"
    className={`mx-auto max-w-3xl rounded-2xl border border-cyan/30 bg-gradient-to-br from-cyan/12 to-transparent p-6 text-center sm:p-7 ${className}`}
  >
    <div className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-cyan/15 text-cyan">
      <Lightbulb size={22} />
    </div>
    <p className="mt-4 font-display text-lg font-700 leading-snug text-white sm:text-xl">
      Vous avez une idée&nbsp;? On réalise <span className="text-cyan">gratuitement</span> votre application
      si elle est sélectionnée par notre comité App Challenge Academy.
    </p>
    <p className="mt-3 font-display text-base font-600 text-cyan">Alors, donnez vite vos idées&nbsp;!</p>
    <Link
      to="/inscription"
      data-testid="aca-promise-cta"
      className="mt-5 inline-flex items-center gap-2 rounded-full bg-cyan px-7 py-3 text-sm font-700 uppercase tracking-wide text-void transition-all hover:glow-cyan"
    >
      Déposer mon idée <ArrowRight size={16} />
    </Link>
  </div>
);

export default AcaPromiseBanner;
